// extracted by mini-css-extract-plugin
export default {"dashboardLayoutWrapper":"dashBoardLayout_dashboardLayoutWrapper__6997r","mobileLayoutWrapper":"dashBoardLayout_mobileLayoutWrapper__l1xpv"};